import PropTypes from "prop-types";

const AccordionItem = ({ faq, active, onToggle }) => {
  const { foodCategory, foodItem } = faq;

  return (
    <li className={`accordion_item ${active ? "active" : ""}`}>
      <button className="button" onClick={onToggle} aria-expanded={active}>
        {foodCategory}
        <span className="control">
          {active ? "▼" : "▶"} {/* Down arrow for active state, Right arrow for inactive state */}
        </span>
      </button>
      <div
        className={`answer_wrapper ${active ? "expanded" : ""}`}
        aria-hidden={!active}
      >
        <div className="answer">{foodItem}</div>
      </div>
    </li>
  );
};

AccordionItem.propTypes = {
  faq: PropTypes.shape({
    foodCategory: PropTypes.string.isRequired,
    foodItem: PropTypes.string.isRequired,
  }).isRequired,
  active: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default AccordionItem;
